var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ods-container",class:{ 'is-vertical': _vm.isVertical },attrs:{"data-name":"OdsContainer"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }